import { LinkButton, Text } from '$components'
import { RoutePath } from 'src/enums/routing'
import { InvitationFooter } from './invitation-footer'

export function InvalidInvitationError() {

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Text
        type="h1"
        className="mb-2"
      >
        Oops! it appears your invitation is invalid.
      </Text>

      <Text className="mb-6 max-w-[520px] text-center">
        This invitation may be invalid, has expired or has been revoked. Please contact your organisation&apos;s administrator for assistance.
      </Text>

      <LinkButton
        variant="secondary"
        to={RoutePath.Root}
      >
        Return to home
      </LinkButton>

      <div className="max-w-[520px] w-full">
        <InvitationFooter />
      </div>
    </div>
  )
}
